import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CheckDateDiffDatepickerPipe } from './pipes/check-date-diff-datepicker.pipe';
import { GaugeComponent } from './gauge/gauge.component';
import { TreeNodeComponent } from './navbar/tree-node/tree-node.component';
import { TreeComponent } from './navbar/tree/tree.component';
import { TreeRootComponent } from './navbar/tree-root/tree-root.component';
import { TreeNodeChildrenComponent } from './navbar/tree-node-children/tree-node-children.component';
import { TreeNodeDropSlotComponent } from './navbar/tree-node-drop-slot/tree-node-drop-slot.component';
import { TreeDragDirective } from './navbar/directives/tree-drag.directive';
import { TreeDropDirective } from './navbar/directives/tree-drop.directive';

@NgModule({
  declarations: [
    CheckDateDiffDatepickerPipe,
    GaugeComponent,
    TreeNodeComponent,
    TreeComponent,
    TreeRootComponent,
    TreeNodeChildrenComponent,
    TreeNodeDropSlotComponent,
    TreeDragDirective,
    TreeDropDirective
  ],
  imports: [CommonModule],
  exports: [
    CheckDateDiffDatepickerPipe,
    GaugeComponent,
    TreeNodeComponent,
    TreeComponent,
    TreeRootComponent,
    TreeNodeChildrenComponent,
    TreeNodeDropSlotComponent,
    TreeDragDirective,
    TreeDropDirective
  ],
})
export class CoreLibModule {}
